// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPage-cls1_pGd","cls2":"MarketingPage-cls2_gpq MarketingPage-cls1_pGd"};